import { ArrowTopRightOnSquareIcon } from "@heroicons/react/24/outline";
import { Button } from "common/src/styles";
import { getTxBlockExplorerLink } from "common";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function TransactionButton(props) {
  return /*#__PURE__*/_jsx("a", {
    target: "_blank",
    href: getTxBlockExplorerLink(props.chainId, props.txHash),
    children: /*#__PURE__*/_jsxs(Button, {
      type: "button",
      $variant: "external-link",
      className: "text-sm flex flex-row items-center border border-grey-100 rounded-lg text-black font-mono p-2",
      children: [/*#__PURE__*/_jsx(ArrowTopRightOnSquareIcon, {
        className: "h-3 inline mx-2"
      }), props.txHash.slice(0, 5) + "..." + props.txHash.slice(-5)]
    })
  });
}